module.exports = __webpack_public_path__ + "img/text_wave_l.718cf0f0.png";